import { Injectable } from "@angular/core";

import * as moment from "moment";


@Injectable()
export class HtmlBaseExpressionsResultService {

    public collapse(values: any[]): string {
        if (!values?.length) return null;

        // If some result holds a node, then they cannot be collapsed.
        if (values.some(value => value instanceof Node)) return null;

        // Stringify and join all the string values.
        return values.map(value => this.stringify(value)).join("");
    }

    public convert(value: any): string | Node {
        if (value == null) return null;

        // If the result is a node, return it as it is.
        if (value instanceof Node) return value;

        return this.stringify(value);
    }

    public stringify(value: any): string {
        if (value == null) return null;

        if (typeof value === "string") return value;

        // Stringify dates separately, to give them the proper format.
        if (value instanceof Date) {
            return moment(value).format("DD/MM/YYYY");
        }

        // Stringify remaining object types using general stringify.
        return JSON.stringify(value);
    }

    public supported(value: any): value is boolean | string | number | Date {
        if (value == null) return true;

        // All basic types and dates are supported.
        return (
            typeof value === "boolean" ||
            typeof value === "string" ||
            typeof value === "number" ||
            value instanceof Date
        );
    }
}